import { render, staticRenderFns } from "./ModalDownloadClaimRetur.vue?vue&type=template&id=08264822&"
import script from "./ModalDownloadClaimRetur.vue?vue&type=script&lang=js&"
export * from "./ModalDownloadClaimRetur.vue?vue&type=script&lang=js&"
import style0 from "./ModalDownloadClaimRetur.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports